import React from 'react'
import { useSelector } from 'react-redux'
import { createSelector } from 'reselect'
import last from 'lodash/last'
import { useKeyPress } from 'react-nb-hooks'

import { useLKModal } from './LKModal'

const getLastOpenModal = createSelector(
  (state) => state.common.openedModals,
  (modals) => last(modals),
)

const Handler = React.memo(({ targetKey, onKey, deps }) => {
  useKeyPress(targetKey, onKey, deps)

  return null
})

Handler.defaultProps = {
  deps: [],
}

/**
 * handler is disabled in case:
 * - modal is opened and handler is rendered outside of LKModal
 * - modal is opened and handler is rendered in another LKModal
 */
const KeyHandler = ({ targetKey, onKey, deps }) => {
  const activeModal = useSelector(getLastOpenModal)

  const { name: modalName } = useLKModal()

  if (activeModal && (!modalName || activeModal !== modalName)) {
    return null
  }

  return <Handler targetKey={targetKey} onKey={onKey} deps={deps} />
}

export default KeyHandler
